import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push } from 'react-router-redux';
import Button from 'shared/lib/components/Button';
import isEmpty from 'lodash/isEmpty';
import { saveClaimsDeviceDamageDescription } from '../../store/actions';
import * as analytics from 'shared/lib/analytics';
import './ClaimsDamageDescription.css';


class ClaimsDamageDescription extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isNextButtonEnabled: false,
    };
  }

  componentDidMount() {
    document.title = `Claims | Damage Description - Sure`;
    analytics.page('Portal - Claim Smartphone Damage Description', {
      category: 'claim',
    });
  }

  updateDamageDescription() {
    this.props.saveClaimsDeviceDamageDescription(this.textarea.value);
  }

  handleNext() {
    const { verticalCode, policyNumber } = this.props.params;

    analytics.track('Portal - Claim Smartphone Damage Description Next Clicked', {
      category: 'claim',
      value: this.textarea.value.length,
    });
    this.props.navTo(`/account/claims/new/${verticalCode}/policies/${policyNumber}/authorization-email`);
  }

  render() {
    return (
      <div className="ClaimsDamageDescription">
        <div className="Container Container--small">
          <h1 className="ClaimsDamageDescription-heading">
            Please write a short description about your device's issue.
          </h1>
          <textarea
            className="ClaimsDamageDescription-textarea"
            placeholder="Tell us about the issue."
            ref={(c) => this.textarea = c}
            value={this.props.claimsDeviceDamageDescription || ''}
            onChange={this.updateDamageDescription.bind(this)}
          />
          <Button
            disabled={isEmpty(this.props.claimsDeviceDamageDescription)}
            onClick={this.handleNext.bind(this)}>
            Next
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    claimsDeviceDamageDescription: state.claimsDeviceDamageDescription,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    navTo: (route) => dispatch(push(route)),
    saveClaimsDeviceDamageDescription: (description) => dispatch(saveClaimsDeviceDamageDescription(description)),
  };
};

export default connect(
  mapStateToProps, mapDispatchToProps
)(withRouter(ClaimsDamageDescription));
